const iHelpers = {
    getKeyByValue(array, key) {
        let result;

        Object.keys(array).forEach((k) => {
            if (array[k] === key) {
                result = k;
            }
        });

        return result;
    },

    getMapOfSerializedData(data) {
        const map = {};
        jQuery.each(data.split('&'), (index, element) => {
            const nv = element.split('=');
            const n = decodeURIComponent(nv[0]);
            const v = nv.length > 1 ? decodeURIComponent(nv[1].replace(/%2B|\+/g, ' ')) : null;
            if (!(n in map)) {
                map[n] = [];
            }
            map[n].push(v);
        });
        return map;
    },
};

export default iHelpers;
